import GlobalVariable from '@/global/global-variable'

// 查询类型
const findTypeApi = GlobalVariable.BASE_PATH + "/rest/type/find";

export default {
    // 查询类型
    findTypeApi,
}



// WEBPACK FOOTER //
// ./src/request/api-type.js